export default [
  {
    name: 'template-emails',
    path: '/event/emails',
    component: () => import(/* webpackChunkName: "event" */ './Index.vue'),
    meta: {
      showNavbar: true,
      title: 'E-mail',
      icon: 'dvr',
      label: 'E-mail'
    }
  },
  {
    name: 'template-email-new',
    path: '/event/emails/create',
    component: () => import(/* webpackChunkName: "event" */ './FormCreate.vue'),
    meta: {
      showNavbar: false,
      title: 'E-mail - Novo Template',
      icon: 'dvr',
      label: 'E-mail - Novo Template'
    }
  },
  {
    name: 'template-email-edit',
    path: '/event/emails/:id/show',
    component: () => import(/* webpackChunkName: "event" */ './FormCreate.vue'),
    meta: {
      showNavbar: false,
      title: 'E-mail - Edição',
      icon: 'dvr',
      label: 'E-mail - Edição'
    }
  }
]
